import './Settings.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import Logger from '@KrashidBuilt/common/utils/logger';


import { ROUTE_MAP } from '../../routes';
import { NavItem } from '../../components';

import Templates from './Templates';
import Checklists from './Checklists';
import Colors from './Colors';
import TemplateCreateEdit from './Templates/TemplateCreateEdit';
import ChecklistCreateEdit from './Checklists/ChecklistCreateEdit';
import ColorCreateEdit from './Colors/ColorCreateEdit';
import RemnantTemplate from './RemTemplateCreateEdit/RemTemplateCreateEdit';
import JobSheetTemplateCreateEdit from './JobSheetTemplateCreateEdit/JobSheetTemplateCreateEdit';
import SPEEDlink from './SPEEDlink';
import { UserContext } from '../../ctx';

const logger = new Logger('Settings');

/**
 * Parts Component
 * @augments {Component<Props, State>}
 */
class Settings extends Component {

    componentDidMount() {
        logger.extra({ _: this });
        // const { match: { path } } = this.props;

        // default to templates
        // if (path === ROUTE_MAP.SETTINGS.ROOT) {
        //     this.props.history.push(ROUTE_MAP.SETTINGS.TEMPLATES);
        //     // this.props.history.push(ROUTE_MAP.SETTINGS.CHECKLISTS);
        // }
    }


    build = (r) => {

        if (!r.props) {
            r.props = {};
        }

        return (
            <Route
                key={r.path}
                exact={r.exact}
                path={r.path}
                render={(props) => (
                    <r.screen key={r.path} {...this.props} {...props} {...r.props} />
                )}
            />
        );

    }

    render() {
        logger.extra({ _: this });

        const isEditing = (label) => {
            const { pathname } = window.location;
            const separated = pathname.split('/');
            const path = separated[separated.length - 2];
            const id = Number(separated[separated.length - 1]);
            return (path == label) && (typeof id == 'number');
        };

        const routes = [
            {
                label: isEditing('templates') ? '← Back To Templates' : 'Templates',
                path: ROUTE_MAP.SETTINGS.TEMPLATES,
                screen: Templates,
                exact: true,
            },
            {
                path: ROUTE_MAP.SETTINGS.TEMPLATE_ID,
                screen: TemplateCreateEdit,
                exact: true,
            },
            {
                label: isEditing('colors') ? '← Back To Color Bands' : 'Color Bands',
                path: ROUTE_MAP.SETTINGS.COLORS,
                screen: Colors,
                exact: true,
            },
            {
                path: ROUTE_MAP.SETTINGS.COLOR_ID,
                screen: ColorCreateEdit,
                exact: true,
            },
            {
                label: isEditing('checklists') ? '← Back To Side Form' : 'Side Form',
                path: ROUTE_MAP.SETTINGS.CHECKLISTS,
                screen: Checklists,
                exact: true,
            },
            {
                path: ROUTE_MAP.SETTINGS.CHECKLIST_ID,
                screen: ChecklistCreateEdit,
                exact: true,
            },
            {
                label: 'SPEEDlink',
                path: ROUTE_MAP.SETTINGS.SPEED_LINK,
                screen: SPEEDlink,
                exact: true,
            },
            {
                label: 'Remnant Template',
                path: ROUTE_MAP.SETTINGS.REMNANT_TEMPLATE,
                screen: RemnantTemplate,
                exact: true,
            },
            {
                label: 'Job Sheet Template',
                path: ROUTE_MAP.SETTINGS.JOB_SHEET_TEMPLATE,
                screen: JobSheetTemplateCreateEdit,
                exact: true,
            }
        ];

        return (
            <div className={'Settings'}>
                <div className={'SubNavigation'}>
                    {routes.map((r) => {
                        const noRender = [ROUTE_MAP.SETTINGS.REMNANT_TEMPLATE, ROUTE_MAP.SETTINGS.JOB_SHEET_TEMPLATE, this.context?.user?.dId != 1 && ROUTE_MAP.SETTINGS.CUSTOM]; // don't render these paths as nav items
                        if (r.label && !noRender.includes(r?.path)) {
                            return (<NavItem className={'sub'} to={r.path} label={r.label} />);
                        }
                    })
                    }
                </div>

                {routes.map(this.build)}
            </div>
        );
    }
}

Settings.contextType = UserContext;

Settings.defaultProps = {
};

Settings.propTypes = {
    match: PropTypes.shape(),
    history: PropTypes.shape(),
};


export default Settings;
